/**
 * Scan & Share counters (frozen contract SSC).
 *
 * GET /api/organisation/abha/scan-share/counters -> { hip_id, share_base_url, counters: [{counter_id, name, type, qr_text}] }
 * PUT same path (ADMIN) body { counters: [{counter_id, name, type}] } -> same shape; 422 {code, message, field}.
 * qr_text is built by the server (null when HIP ID or base URL is missing) - the FE never builds the URL.
 */
import apiClient from './apiClient';

const PATH = '/api/organisation/abha/scan-share/counters';

export const COUNTER_TYPES = { OPD: 'OPD', IPD: 'IPD' };
export const MAX_COUNTERS = 50;

const shape = (d) => ({
  hipId: d?.hip_id || null,
  shareBaseUrl: d?.share_base_url || null,
  counters: (d?.counters || []).map((c) => ({
    counterId: c.counter_id,
    name: c.name,
    type: c.type,
    qrText: c.qr_text || null,
  })),
});

export async function getScanCounters() {
  const res = await apiClient.get(PATH);
  return shape(res.data);
}

export async function putScanCounters(counters) {
  try {
    const res = await apiClient.put(PATH, {
      counters: counters.map((c) => ({ counter_id: c.counterId, name: c.name, type: c.type })),
    });
    return shape(res.data);
  } catch (err) {
    const d = err?.response?.data?.detail ?? err?.response?.data;
    const e = new Error(d?.message || 'Could not save the counters. Please try again.');
    e.field = d?.field;
    throw e;
  }
}
